import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Tag } from '../../shared/models/tag.model';
import { getAwardName, getAwardYear, getBadgeImageUrl, getCurrentFteAwardTags, getHistoricalFteAwardTags } from '../../util/tag-utils';
import { ReportCardPdfService } from '../../shared/services/report-card-pdf.service';

@Component({
  selector: 'app-awards-and-recognitions',
  templateUrl: './awards-and-recognitions.component.html',
  styleUrls: ['./awards-and-recognitions.component.scss']
})
export class AwardsAndRecognitionsComponent implements OnInit, OnChanges {
  @Input() awardTags: Tag[];
  @Input() displayHistoricalBadges: boolean;
  @Input() displayReportCard: boolean;
  @Input() businessId: string;
  @Input() fteAwardYear: string;

  tagsToDisplay: Tag[];
  oldTagsToDisplay: Tag[];
  constructor(private reportCardPdfService: ReportCardPdfService) { }

  ngOnInit() {
    if (this.displayHistoricalBadges) {
      this.tagsToDisplay = getCurrentFteAwardTags(this.awardTags);
      this.oldTagsToDisplay = getHistoricalFteAwardTags(this.awardTags);
    } else {
      this.tagsToDisplay = getCurrentFteAwardTags(this.awardTags);
      this.oldTagsToDisplay = [];
    }
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  getAwardName(tagName: string): string {
    return getAwardName(tagName);
  }

  getBadgeImageUrl(tagName: string): string {
    return getBadgeImageUrl(tagName);
  }

  clickReportCard() {
    this.reportCardPdfService.getReportCardPdf(this.businessId, this.fteAwardYear).subscribe(res => {
      const fileURL = URL.createObjectURL(res);
      window.open(fileURL, '_blank', 'noreferrer');
    });
  }

  getReportCardBadgeUrl(): string {
    return 'https://www.aopa.org/-/media/Images/passport/2023/FTSurvey/2206_Flight_School_Report_Card%20Badge_400x400';
  }
}
